module.exports = __webpack_public_path__ + "img/CF_2X.1.a3fa0b17.jpg";